/** @jsx jsx */

import { RefObject, useRef } from "react";
import { css, jsx } from "@emotion/react";
import useDimensions from "hooks/useDimensions";
import { useEffect } from "react";

/**
 * You give me a list of elements, of the same fixed height,
 * and I tell you how many of them I can fit.
 */
export default function FittingBox({children,
                                    firstChildRef,
                                    numFitCallback:iCanFit,
                                    lowerHeightBy = 0, 
                                    ...props}:FittingBoxProps) {
    const {height:childHeight} = useDimensions(firstChildRef)

    const myRef = useRef()
    const {height:myHeight} = useDimensions(myRef)

    useEffect(()=> {
        if(childHeight && myHeight) {
            const thisManyChildren = Math.floor((myHeight-lowerHeightBy)/childHeight)
            iCanFit(thisManyChildren)
        }
    },[myHeight,childHeight,iCanFit,lowerHeightBy])

    return (
        <div ref={myRef} css={fittingBoxCss} {...props}>
            {children}
        </div>
    )
}
interface FittingBoxProps {
    firstChildRef: RefObject<HTMLElement>;
    children:Array<jsx.JSX.Element>;
    numFitCallback: (numFit:number)=>void;
    /** 
     * Pretend like the total height is this much lower than it is
     */
    lowerHeightBy?:number;
    [key:string]:unknown
}

const fittingBoxCss = css`
    height:100%
`
